// extracted by mini-css-extract-plugin
export var arrows = "_42-6";
export var decrementer = "_42-a";
export var disabled = "_42-4";
export var error = "_42-1";
export var hiddenText = "_42-b";
export var incrementer = "_42-9";
export var input = "_42-8";
export var inputWrapper = "_42-0";
export var leadingIcon = "_42-c";
export var readonly = "_42-3";
export var regular = "_42-7";
export var small = "_42-5";
export var warning = "_42-2";